import React, { useState } from "react";
import Navbar from "../components/Navbar";
import { ReactTyped } from "react-typed";
import Footer from "../components/Footer";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
// import axios from "axios";

const Contact = () => {
  // const [name, setName] = useState("");
  // const [email, setEmail] = useState("");
  // const [phone, setPhone] = useState("");
  // const [msg, setMsg] = useState("");
  // const [isSubmitted, setIsSubmitted] = useState(false);

  // async function handleSubmit(e) {
  //   e.preventDefault();
  //   setIsSubmitted(true);
  //   setName("");
  //   setEmail("");
  //   setPhone("");
  //   setMsg("");
  //   // await axios
  //   //   .post("https://my-portfolio-api-g8v1.onrender.com/email", {
  //   //     name,
  //   //     email,
  //   //     phone,
  //   //     msg,
  //   //   })
  //   //   .then((res) => {
  //   //     console.log(res);

  //   //     alert("Mail Sent Successfully");
  //   //   })
  //   //   .catch((err) => {
  //   //     alert("Failed");
  //   //     console.log(err);
  //   //   });
  // }

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch("https://formspree.io/f/meozqvnk", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          _replyto: formData.email,
          _subject: "New contact from portfolio"
        }),
      });

      if (response.ok) {
        setShowSuccess(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: ""
        });
        // Hide success message after 3 seconds
        setTimeout(() => setShowSuccess(false), 3000);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div>
      <Navbar />
      <div className="text-white max-w-[800px] mt-[-96px] mb-[20px] w-full h-screen  mx-auto pl-2 font-main">
        <div className="pt-[130px]">
          <h1 className="text-[#00df9a] uppercase text-3xl">Contact Me</h1>
          {showSuccess && (
            <div className="text-green-500 mt-2">
              Message sent successfully!
            </div>
          )}
        </div>
        {/* <div> */}
        <div className="flex">
          <div className="w-1/2 pr-4">
          <form 
            className="flex flex-col text-black" onSubmit={handleSubmit}> 
            {/* action="https://formspree.io/f/meozqvnk" 
            method="POST"
            // onSubmit={handleSubmit}
          > */}
          {/* <form className="flex flex-col text-black" onSubmit={handleSubmit}> */}
            <div className="py-4">
              {/* {" "} */}
              <input
                className="p-2 text-black"
                placeholder="Name"
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
              ></input>
            </div>
            <div className="py-4">
              {/* {" "} */}
              <input
                className="p-2"
                placeholder="Email"
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
              ></input>
            </div>
            <div className="py-4">
              {/* {" "} */}
              <input
                className="p-2"
                placeholder="Phone No"
                type="tel"
                name="phone"
                required
                value={formData.phone}
                onChange={handleChange}
              ></input>
            </div>
            <div className="py-4">
              {/* {" "} */}
              <textarea
                className="p-2"
                placeholder="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            {/* <input type="hidden" name="_replyto" value={email} />
            <input type="hidden" name="_subject" value="New contact from portfolio" /> */}
            {/* <input type="hidden" name="_next" value="/thank-you" /> */}
            <div>
              <button
                type="submit"
                className="text-white border-[1px] border-white border-solid rounded-[100px] p-2 hover:bg-[#00df9a] hover:text-black transition-colors duration-300"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </div>
          </form>
        </div>
          <div className="w-1/2 pl-4">
            {/* Contact Details */}
            <div className="text-white space-y-6 mb-8">
              <div className="flex items-center">
                <FaPhone className="text-[#00df9a] mr-4 text-xl" />
                <div>
                  <p className="text-gray-400">Phone</p>
                  <p className="text-lg">+1 (774) 525-7594</p>
                </div>
              </div>

              <div className="flex items-center">
                <FaEnvelope className="text-[#00df9a] mr-4 text-xl" />
                <div>
                  <p className="text-gray-400">Email</p>
                  <p className="text-lg">keerthiram231@gmail.com</p>
                </div>
              </div>

              <div className="flex items-start">
                <FaMapMarkerAlt className="text-[#00df9a] mr-4 text-xl mt-1" />
                <div>
                  <p className="text-gray-400">Address</p>
{/*                   <p className="text-lg">16 Winn Terrace<br />Northborough, MA 01532<br />US</p> */}
                  <p className="text-lg">16 Winn Terrace<br />Northborough, MA 01532<br />US</p> 
                </div>
              </div>
            </div>
        {/* <div className="flex flex-col ml-[450px] mt-[-270px]"> */}
        <div className="mt-12">
          <h1 className="text-[#00df9a] md:text-7xl sm:text-6xl text-4xl font-bold ">
            <ReactTyped strings={["Hire"]} typeSpeed={120} />
          </h1>
          <h2 className="text-white md:text-6xl sm:text-5xl text-3xl font-bold ">
            Me...
          </h2>
        </div>
      </div>
      </div>
      </div>
      <div className="mt-[-100px]">
        <Footer />
      </div>
    </div>
  );
};

export default Contact;
